export const HUD_STYLES = `
  @keyframes hud-pulse-dot { 0%,100%{transform:scale(1);opacity:.7} 50%{transform:scale(1.7);opacity:1} }
  @keyframes hud-scan-line  { 0%{top:-80px} 100%{top:100%} }
  @keyframes hud-crit       { 0%,100%{opacity:.55} 50%{opacity:1} }
  @keyframes hud-ring-warn  { 0%,100%{filter:drop-shadow(0 0 3px rgba(239,68,68,.4))} 50%{filter:drop-shadow(0 0 12px rgba(239,68,68,.9))} }
  @keyframes hud-bar-in     { from{width:0} to{width:var(--prog-w,62%)} }
  @keyframes hud-new-bg     { 0%{background:rgba(6,182,212,.22)} 100%{background:rgba(6,182,212,.07)} }
  @keyframes hud-vote-glow  { 0%,100%{box-shadow:0 0 8px rgba(251,191,36,.1)} 50%{box-shadow:0 0 18px rgba(251,191,36,.28)} }
  @keyframes hud-ta-flicker { 0%,95%,100%{opacity:1} 96%{opacity:.7} 98%{opacity:.9} }

  /* ── HUD CONTAINERS ── */
  .hud-panel {
    display:flex; flex-direction:column;
    background:#04050f;
    border:1px solid rgba(255,255,255,.06);
    border-radius:10px;
    overflow:hidden;
    position:relative;
    font-family:ui-monospace,'SF Mono',Menlo,monospace;
  }
  /* coins décoratifs */
  .hud-panel-cyan::before {
    content:''; position:absolute; top:0; left:0; width:18px; height:18px;
    border-top:1px solid rgba(6,182,212,.6); border-left:1px solid rgba(6,182,212,.6); z-index:6; pointer-events:none;
  }
  .hud-panel-cyan::after {
    content:''; position:absolute; bottom:0; right:0; width:18px; height:18px;
    border-bottom:1px solid rgba(6,182,212,.6); border-right:1px solid rgba(6,182,212,.6); z-index:6; pointer-events:none;
  }
  .hud-panel-indigo::before {
    content:''; position:absolute; top:0; left:0; width:18px; height:18px;
    border-top:1px solid rgba(99,102,241,.5); border-left:1px solid rgba(99,102,241,.5); z-index:6; pointer-events:none;
  }
  .hud-panel-indigo::after {
    content:''; position:absolute; bottom:0; right:0; width:18px; height:18px;
    border-bottom:1px solid rgba(99,102,241,.5); border-right:1px solid rgba(99,102,241,.5); z-index:6; pointer-events:none;
  }
  .hud-scanline {
    position:absolute; left:0; right:0; height:90px;
    background:linear-gradient(transparent,rgba(6,182,212,.018),transparent);
    animation:hud-scan-line 8s linear infinite;
    pointer-events:none; z-index:3;
  }
  .hud-sec {
    padding:10px 12px;
    border-bottom:1px solid rgba(255,255,255,.04);
    position:relative; z-index:2;
  }
  .hud-sec:last-child { border-bottom:none; }

  /* ── TIMER ── */
  .hud-timer-svg { animation:hud-ring-warn 2s ease-in-out infinite; }
  .hud-timer-val { font-size:26px; font-weight:900; color:#fca5a5; line-height:1; letter-spacing:.04em; text-shadow:0 0 18px rgba(239,68,68,.35); }
  .hud-timer-val-ok { color:#c7d2fe; text-shadow:0 0 14px rgba(99,102,241,.3); }
  .hud-timer-val-warn { color:#fde68a; text-shadow:0 0 14px rgba(251,191,36,.3); }
  .hud-timer-dot-crit { width:5px; height:5px; border-radius:50%; background:#ef4444; animation:hud-pulse-dot 1s ease-in-out infinite; box-shadow:0 0 7px rgba(239,68,68,.9); }
  .hud-timer-warn-txt { font-size:8px; color:rgba(239,68,68,.8); letter-spacing:.14em; animation:hud-crit 1s ease-in-out infinite; font-weight:700; }
  .hud-timer-lbl { font-size:9px; letter-spacing:.18em; text-transform:uppercase; margin-bottom:2px; font-weight:600; }

  /* ── JOURNAL CARD ── */
  .hud-jrn-card {
    border-radius:9px;
    border:1px solid rgba(6,182,212,.32);
    background:linear-gradient(145deg,rgba(6,182,212,.09) 0%,rgba(6,182,212,.03) 55%,rgba(2,6,23,.5) 100%);
    padding:9px 10px;
    position:relative; overflow:hidden;
  }
  .hud-jrn-card::before {
    content:''; position:absolute; top:0; right:0; width:28px; height:28px;
    border-top:1px solid rgba(6,182,212,.5); border-right:1px solid rgba(6,182,212,.5);
    border-radius:0 8px 0 0; pointer-events:none;
  }
  .hud-jrn-card::after {
    content:''; position:absolute; top:0; left:0; right:0; height:28px;
    background:linear-gradient(to bottom,rgba(6,182,212,.07),transparent);
    pointer-events:none; border-radius:9px 9px 0 0;
  }
  .hud-jrn-live {
    width:7px; height:7px; border-radius:50%;
    background:rgba(6,182,212,1); flex-shrink:0;
    animation:hud-pulse-dot 2s ease-in-out infinite;
    box-shadow:0 0 10px rgba(6,182,212,1);
  }
  .hud-prog-track { height:3px; background:rgba(255,255,255,.06); border-radius:2px; margin-bottom:8px; overflow:hidden; position:relative; z-index:1; }
  .hud-prog-fill {
    height:100%; width:0; border-radius:2px;
    background:linear-gradient(90deg,rgba(6,182,212,.65),rgba(52,211,153,.85));
    animation:hud-bar-in .9s ease-out .15s forwards;
    position:relative;
  }
  .hud-prog-fill::after {
    content:''; position:absolute; right:-1px; top:-1.5px;
    width:6px; height:6px; border-radius:50%;
    background:#34d399; box-shadow:0 0 8px rgba(52,211,153,.95);
  }
  .hud-log-new-row {
    border-left:2px solid rgba(6,182,212,.7);
    padding-left:5px; border-radius:0 4px 4px 0;
    animation:hud-new-bg 2.5s ease-out forwards;
  }

  /* ── ACTIONS CYBER ── */
  .hud-abtn {
    flex:1; display:flex; align-items:center; justify-content:center; gap:5px;
    padding:9px 10px; font-size:9px; letter-spacing:.12em; text-transform:uppercase; font-weight:700;
    cursor:pointer; position:relative; overflow:hidden; transition:all .15s;
    clip-path:polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);
  }
  .hud-abtn-hand {
    background:repeating-linear-gradient(45deg,rgba(255,255,255,.015) 0px,rgba(255,255,255,.015) 1px,transparent 1px,transparent 8px),rgba(148,163,184,.07);
    color:rgba(203,213,225,.8);
    outline:1px solid rgba(148,163,184,.18); outline-offset:-1px;
  }
  .hud-abtn-hand:hover { background:repeating-linear-gradient(45deg,rgba(255,255,255,.025) 0px,rgba(255,255,255,.025) 1px,transparent 1px,transparent 8px),rgba(148,163,184,.13); color:#e2e8f0; outline-color:rgba(148,163,184,.35); }
  .hud-abtn-hand-active {
    background:repeating-linear-gradient(45deg,rgba(245,158,11,.04) 0px,rgba(245,158,11,.04) 1px,transparent 1px,transparent 8px),rgba(245,158,11,.12);
    color:rgba(253,230,138,.95);
    outline:1px solid rgba(245,158,11,.45); outline-offset:-1px;
  }
  .hud-abtn-vote {
    background:repeating-linear-gradient(45deg,rgba(251,191,36,.04) 0px,rgba(251,191,36,.04) 1px,transparent 1px,transparent 8px),rgba(251,191,36,.09);
    color:rgba(253,230,138,.95);
    outline:1px solid rgba(251,191,36,.4); outline-offset:-1px;
    animation:hud-vote-glow 2.5s ease-in-out infinite;
  }
  .hud-abtn-vote:hover { background:repeating-linear-gradient(45deg,rgba(251,191,36,.07) 0px,rgba(251,191,36,.07) 1px,transparent 1px,transparent 8px),rgba(251,191,36,.16); outline-color:rgba(251,191,36,.65); }
  .hud-vote-badge { background:rgba(251,191,36,.3); padding:1px 5px; font-size:8px; color:#fef3c7; font-weight:900; border:1px solid rgba(251,191,36,.4); }

  /* ── TABS ── */
  .hud-tab-bar { display:flex; border-bottom:1px solid rgba(255,255,255,.06); }
  .hud-tab { flex:1; text-align:center; padding:8px 4px; font-size:10px; letter-spacing:.1em; text-transform:uppercase; cursor:pointer; color:rgba(100,116,139,.75); border-bottom:2px solid transparent; transition:all .15s; font-weight:700; }
  .hud-tab:hover { color:rgba(148,163,184,.9); background:rgba(255,255,255,.02); }
  .hud-tab-on { color:rgba(165,180,252,1); border-bottom-color:rgba(99,102,241,.9); text-shadow:0 0 10px rgba(99,102,241,.5); background:rgba(99,102,241,.04); }

  /* filtres mission */
  .hud-mf { font-size:7px; padding:2px 7px; border-radius:10px; border:1px solid rgba(255,255,255,.07); color:rgba(71,85,105,.7); cursor:pointer; letter-spacing:.07em; text-transform:uppercase; transition:all .15s; }
  .hud-mf:hover { border-color:rgba(255,255,255,.15); color:rgba(148,163,184,.8); }
  .hud-mf-on { background:rgba(99,102,241,.15); border-color:rgba(99,102,241,.4); color:rgba(165,180,252,.9); }

  /* ── BRIEF / INDICES CYBER ── */
  .hud-ta-btn {
    flex:1; display:flex; align-items:center; gap:8px;
    padding:9px 10px; cursor:pointer; transition:all .2s;
    position:relative; overflow:hidden;
    clip-path:polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%);
    animation:hud-ta-flicker 8s ease-in-out infinite;
  }
  .hud-ta-brief {
    background:repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.08);
    outline:1px solid rgba(99,102,241,.3); outline-offset:-1px;
    animation-delay:0s;
  }
  .hud-ta-brief:hover { background:repeating-linear-gradient(45deg,rgba(99,102,241,.07) 0,rgba(99,102,241,.07) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.15); outline-color:rgba(99,102,241,.55); }
  .hud-ta-hints {
    background:repeating-linear-gradient(45deg,rgba(245,158,11,.04) 0,rgba(245,158,11,.04) 1px,transparent 1px,transparent 7px),rgba(245,158,11,.07);
    outline:1px solid rgba(245,158,11,.28); outline-offset:-1px;
    animation-delay:1.3s;
  }
  .hud-ta-hints:hover { background:repeating-linear-gradient(45deg,rgba(245,158,11,.07) 0,rgba(245,158,11,.07) 1px,transparent 1px,transparent 7px),rgba(245,158,11,.14); outline-color:rgba(245,158,11,.5); }
  .hud-ta-btn::after {
    content:''; position:absolute; bottom:0; right:0; width:10px; height:10px;
    border-bottom:1px solid; border-right:1px solid; pointer-events:none;
  }
  .hud-ta-brief::after { border-color:rgba(99,102,241,.4); }
  .hud-ta-hints::after { border-color:rgba(245,158,11,.35); }

  /* ── PLAYER CARDS ── */
  .hud-pcard {
    display:flex; align-items:center; gap:9px;
    padding:9px 10px 9px 14px; border-radius:8px;
    border:1px solid rgba(255,255,255,.06);
    background:rgba(255,255,255,.025);
    cursor:pointer; transition:all .15s; position:relative;
  }
  .hud-pcard::before {
    content:''; position:absolute; left:0; top:8px; bottom:8px;
    width:3px; border-radius:0 3px 3px 0; transition:all .15s;
  }
  .hud-pcard:hover { background:rgba(255,255,255,.055); border-color:rgba(255,255,255,.12); }
  .hud-pcard:hover::before { width:4px; }
  .hud-pc-me  { border-color:rgba(99,102,241,.28); background:rgba(99,102,241,.05); }
  .hud-pc-me::before  { background:linear-gradient(180deg,#818cf8,#a78bfa); box-shadow:2px 0 8px rgba(99,102,241,.4); }
  .hud-pc-1::before   { background:linear-gradient(180deg,#818cf8,#a78bfa); box-shadow:2px 0 6px rgba(99,102,241,.25); }
  .hud-pc-2::before   { background:linear-gradient(180deg,#d946ef,#a855f7); box-shadow:2px 0 6px rgba(217,70,239,.25); }
  .hud-pc-3::before   { background:linear-gradient(180deg,#fbbf24,#f59e0b); box-shadow:2px 0 6px rgba(251,191,36,.25); }
  .hud-pc-4::before   { background:linear-gradient(180deg,#34d399,#10b981); box-shadow:2px 0 6px rgba(52,211,153,.25); }
  .hud-pc-5::before   { background:linear-gradient(180deg,#fb923c,#ea580c); box-shadow:2px 0 6px rgba(251,146,60,.25); }
  .hud-pc-6::before   { background:linear-gradient(180deg,#f472b6,#db2777); box-shadow:2px 0 6px rgba(244,114,182,.25); }

  .hud-av { width:32px; height:32px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; font-family:ui-sans-serif,system-ui; position:relative; }
  .hud-av::after { content:''; position:absolute; bottom:-1px; right:-1px; width:8px; height:8px; border-radius:50%; background:#34d399; border:1.5px solid #04050f; box-shadow:0 0 5px rgba(52,211,153,.8); }
  .hud-av-1 { background:rgba(99,102,241,.2);  border:1px solid rgba(99,102,241,.35);  color:#a5b4fc; }
  .hud-av-2 { background:rgba(217,70,239,.15); border:1px solid rgba(217,70,239,.3);   color:#f0abfc; }
  .hud-av-3 { background:rgba(251,191,36,.15); border:1px solid rgba(251,191,36,.25);  color:#fde68a; }
  .hud-av-4 { background:rgba(52,211,153,.15); border:1px solid rgba(52,211,153,.25);  color:#6ee7b7; }
  .hud-av-5 { background:rgba(251,146,60,.15); border:1px solid rgba(251,146,60,.25);  color:#fdba74; }
  .hud-av-6 { background:rgba(244,114,182,.15);border:1px solid rgba(244,114,182,.25); color:#fbcfe8; }
  .hud-ptag { font-size:7px; background:rgba(99,102,241,.2); border:1px solid rgba(99,102,241,.4); color:rgba(165,180,252,.9); padding:1px 4px; border-radius:2px; letter-spacing:.06em; flex-shrink:0; }
  .hud-peye { font-size:9px; color:rgba(71,85,105,.4); flex-shrink:0; transition:color .15s; }
  .hud-pcard:hover .hud-peye { color:rgba(148,163,184,.7); }

  /* ── PREVIEW ZONE ── */
  .hud-prev-zone {
    flex:1; min-height:70px;
    background:rgba(255,255,255,.015);
    border:1px solid rgba(255,255,255,.05);
    border-radius:7px;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    gap:5px; cursor:pointer; transition:all .2s; position:relative; overflow:hidden;
  }
  .hud-prev-zone::before { content:''; position:absolute; inset:0; background:radial-gradient(ellipse at 50% 0%,rgba(99,102,241,.05),transparent 70%); }
  .hud-prev-zone:hover { background:rgba(255,255,255,.04); border-color:rgba(99,102,241,.22); }

  /* ── MISC ── */
  .hud-divh { height:1px; background:rgba(255,255,255,.06); }
  .hud-inv { display:flex; align-items:center; gap:6px; padding:8px 14px; border-top:1px solid rgba(255,255,255,.05); }
  .hud-inv-dot { width:5px; height:5px; border-radius:50%; background:rgba(100,116,139,.7); }
  .hud-inv-txt { font-size:11px; letter-spacing:.06em; color:rgba(148,163,184,.7); font-family:ui-sans-serif,system-ui; }
`;

export const TUTORIAL_HUD_STYLES = `
  @keyframes hud-pulse-dot { 0%,100%{transform:scale(1);opacity:.7} 50%{transform:scale(1.7);opacity:1} }
  @keyframes hud-scan-line  { 0%{top:-80px} 100%{top:100%} }
  @keyframes hud-crit       { 0%,100%{opacity:.55} 50%{opacity:1} }
  @keyframes hud-ring-warn  { 0%,100%{filter:drop-shadow(0 0 3px rgba(239,68,68,.4))} 50%{filter:drop-shadow(0 0 12px rgba(239,68,68,.9))} }
  @keyframes hud-bar-in     { from{width:0} to{width:var(--prog-w,62%)} }
  @keyframes hud-ta-flicker { 0%,95%,100%{opacity:1} 96%{opacity:.7} 98%{opacity:.9} }
  @keyframes tuto-progress  { from{width:0} }

  .hud-panel {
    display:flex; flex-direction:column;
    background:#04050f;
    border:1px solid rgba(255,255,255,.06);
    border-radius:10px; overflow:hidden; position:relative;
    font-family:ui-monospace,'SF Mono',Menlo,monospace;
  }
  .hud-panel-cyan::before { content:''; position:absolute; top:0; left:0; width:18px; height:18px; border-top:1px solid rgba(6,182,212,.6); border-left:1px solid rgba(6,182,212,.6); z-index:6; pointer-events:none; }
  .hud-panel-cyan::after  { content:''; position:absolute; bottom:0; right:0; width:18px; height:18px; border-bottom:1px solid rgba(6,182,212,.6); border-right:1px solid rgba(6,182,212,.6); z-index:6; pointer-events:none; }
  .hud-panel-indigo::before { content:''; position:absolute; top:0; left:0; width:18px; height:18px; border-top:1px solid rgba(99,102,241,.5); border-left:1px solid rgba(99,102,241,.5); z-index:6; pointer-events:none; }
  .hud-panel-indigo::after  { content:''; position:absolute; bottom:0; right:0; width:18px; height:18px; border-bottom:1px solid rgba(99,102,241,.5); border-right:1px solid rgba(99,102,241,.5); z-index:6; pointer-events:none; }

  .hud-sec { padding:10px 12px; border-bottom:1px solid rgba(255,255,255,.04); position:relative; z-index:2; }
  .hud-sec:last-child { border-bottom:none; }

  .hud-timer-val    { font-size:24px; font-weight:900; color:#c7d2fe; line-height:1; letter-spacing:.04em; text-shadow:0 0 14px rgba(99,102,241,.3); }
  .hud-timer-lbl    { font-size:9px; letter-spacing:.18em; text-transform:uppercase; margin-bottom:2px; font-weight:600; color:rgba(129,140,248,.75); }

  .hud-jrn-card {
    border-radius:9px; border:1px solid rgba(6,182,212,.32);
    background:linear-gradient(145deg,rgba(6,182,212,.09) 0%,rgba(6,182,212,.03) 55%,rgba(2,6,23,.5) 100%);
    padding:9px 10px; position:relative; overflow:hidden;
  }
  .hud-jrn-card::before { content:''; position:absolute; top:0; right:0; width:28px; height:28px; border-top:1px solid rgba(6,182,212,.5); border-right:1px solid rgba(6,182,212,.5); border-radius:0 8px 0 0; pointer-events:none; }
  .hud-jrn-card::after  { content:''; position:absolute; top:0; left:0; right:0; height:28px; background:linear-gradient(to bottom,rgba(6,182,212,.07),transparent); pointer-events:none; border-radius:9px 9px 0 0; }

  .hud-abtn {
    flex:1; display:flex; align-items:center; justify-content:center; gap:5px;
    padding:9px 10px; font-size:9px; letter-spacing:.12em; text-transform:uppercase; font-weight:700;
    cursor:default; position:relative; overflow:hidden;
    clip-path:polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);
  }
  .hud-abtn-hand {
    background:repeating-linear-gradient(45deg,rgba(255,255,255,.015) 0px,rgba(255,255,255,.015) 1px,transparent 1px,transparent 8px),rgba(148,163,184,.07);
    color:rgba(203,213,225,.8); outline:1px solid rgba(148,163,184,.18); outline-offset:-1px;
  }

  .hud-tab-bar { display:flex; border-bottom:1px solid rgba(255,255,255,.06); }
  .hud-tab { flex:1; text-align:center; padding:8px 4px; font-size:10px; letter-spacing:.1em; text-transform:uppercase; cursor:default; color:rgba(100,116,139,.75); border-bottom:2px solid transparent; font-weight:700; }
  .hud-tab-on { color:rgba(165,180,252,1); border-bottom-color:rgba(99,102,241,.9); text-shadow:0 0 10px rgba(99,102,241,.5); background:rgba(99,102,241,.04); }

  .hud-ta-btn {
    flex:1; display:flex; align-items:center; gap:8px;
    padding:9px 10px; cursor:default; position:relative; overflow:hidden;
    clip-path:polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%);
  }
  .hud-ta-brief {
    background:repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.08);
    outline:1px solid rgba(99,102,241,.3); outline-offset:-1px;
  }
  .hud-ta-hints {
    background:repeating-linear-gradient(45deg,rgba(245,158,11,.04) 0,rgba(245,158,11,.04) 1px,transparent 1px,transparent 7px),rgba(245,158,11,.07);
    outline:1px solid rgba(245,158,11,.28); outline-offset:-1px;
  }
  .hud-ta-btn::after { content:''; position:absolute; bottom:0; right:0; width:10px; height:10px; border-bottom:1px solid; border-right:1px solid; pointer-events:none; }
  .hud-ta-brief::after { border-color:rgba(99,102,241,.4); }
  .hud-ta-hints::after { border-color:rgba(245,158,11,.35); }

  .hud-pcard {
    display:flex; align-items:center; gap:9px;
    padding:9px 10px 9px 14px; border-radius:8px;
    border:1px solid rgba(255,255,255,.06); background:rgba(255,255,255,.025);
    position:relative;
  }
  .hud-pcard::before { content:''; position:absolute; left:0; top:8px; bottom:8px; width:3px; border-radius:0 3px 3px 0; }
  .hud-pc-1::before { background:linear-gradient(180deg,#818cf8,#a78bfa); box-shadow:2px 0 6px rgba(99,102,241,.25); }
  .hud-pc-2::before { background:linear-gradient(180deg,#d946ef,#a855f7); box-shadow:2px 0 6px rgba(217,70,239,.25); }
  .hud-pc-3::before { background:linear-gradient(180deg,#fbbf24,#f59e0b); box-shadow:2px 0 6px rgba(251,191,36,.25); }
  .hud-pc-4::before { background:linear-gradient(180deg,#34d399,#10b981); box-shadow:2px 0 6px rgba(52,211,153,.25); }
  .hud-pc-me { border-color:rgba(99,102,241,.28); background:rgba(99,102,241,.05); }
  .hud-pc-me::before { background:linear-gradient(180deg,#818cf8,#a78bfa); box-shadow:2px 0 8px rgba(99,102,241,.4); }

  .hud-av { width:32px; height:32px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; font-family:ui-sans-serif,system-ui; position:relative; }
  .hud-av::after { content:''; position:absolute; bottom:-1px; right:-1px; width:8px; height:8px; border-radius:50%; background:#34d399; border:1.5px solid #04050f; box-shadow:0 0 5px rgba(52,211,153,.8); }
  .hud-av-1 { background:rgba(99,102,241,.2);  border:1px solid rgba(99,102,241,.35);  color:#a5b4fc; }
  .hud-av-2 { background:rgba(217,70,239,.15); border:1px solid rgba(217,70,239,.3);   color:#f0abfc; }
  .hud-av-3 { background:rgba(251,191,36,.15); border:1px solid rgba(251,191,36,.25);  color:#fde68a; }
  .hud-av-4 { background:rgba(52,211,153,.15); border:1px solid rgba(52,211,153,.25);  color:#6ee7b7; }
  .hud-ptag { font-size:7px; background:rgba(99,102,241,.2); border:1px solid rgba(99,102,241,.4); color:rgba(165,180,252,.9); padding:1px 4px; border-radius:2px; letter-spacing:.06em; flex-shrink:0; }

  .hud-prev-zone {
    flex:1; min-height:60px; background:rgba(255,255,255,.015); border:1px solid rgba(255,255,255,.05);
    border-radius:7px; display:flex; flex-direction:column; align-items:center; justify-content:center;
    gap:5px; position:relative; overflow:hidden;
  }
  .hud-prev-zone::before { content:''; position:absolute; inset:0; background:radial-gradient(ellipse at 50% 0%,rgba(99,102,241,.05),transparent 70%); }

  .hud-divh { height:1px; background:rgba(255,255,255,.06); }
  .hud-inv { display:flex; align-items:center; gap:6px; padding:8px 14px; border-top:1px solid rgba(255,255,255,.05); }
  .hud-inv-dot { width:5px; height:5px; border-radius:50%; background:rgba(100,116,139,.7); }
  .hud-inv-txt { font-size:11px; letter-spacing:.06em; color:rgba(148,163,184,.7); font-family:ui-sans-serif,system-ui; }
`;

// Couleurs par variant (index 0 = variant 1)
const VARIANT_COLORS = ["1", "2", "3", "4", "5", "6"];
export function variantColorClass(variant) {
  return `hud-pc-${VARIANT_COLORS[(variant - 1) % 6] || "1"}`;
}
export function variantAvClass(variant) {
  return `hud-av-${VARIANT_COLORS[(variant - 1) % 6] || "1"}`;
}